import {Button} from '@chekinapp/ui';
import {useTranslation} from 'react-i18next';
import dataIncompleteIcon from 'assets/icons/incomplete.svg?no-inline';
import ModalSheet from '../common/ModalSheet';
import {Content} from './styled';

type ModalTypes = {
  open: boolean;
  onClose: () => void;
};

function IncompleteRegisterModal({open, onClose}: ModalTypes) {
  const {t} = useTranslation();

  return (
    <ModalSheet
      isOpenModalSheet={open}
      handleCloseModal={onClose}
      maxWidth={375}
      className="kiosko:py-15"
    >
      <Content className="incomplete-register-modal kiosko:gap-12">
        <img
          src={dataIncompleteIcon}
          alt={t('form_with_red_field')}
          width={50}
          height={50}
          className="incomplete-register-modal__img kiosko:w-[90px] kiosko:h-[90px]"
        />
        <h1 className="incomplete-register-modal__title kiosko:!text-kiosko-l kiosko:mt-14 kiosko:leading-normal">
          {t('incomplete_personal_data')}
        </h1>
        <p className="incomplete-register-modal__text kiosko:!text-kiosko-m kiosko:leading-normal">
          {t('at_least_one_field_is_missing')}
        </p>
        <Button onClick={onClose} className="mt-6 max-[479px]:mb-[30px]">
          {t('ok')}
        </Button>
      </Content>
    </ModalSheet>
  );
}

export {IncompleteRegisterModal};
